// i18n.ts
import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import arTranslation from './locales/ar.json';
import enTranslation from './locales/en.json';

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: { translations: enTranslation },
            ar: { translations: arTranslation },
        },
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        lng: localStorage.getItem('language') || 'en',
        ns: ['translations'],
        defaultNS: 'translations',
    });

export default i18n;
